import { useTranslation } from 'react-i18next';
import { SimpleSelectOptionFormatter, useArrayToSimpleSelectOption } from '../selects';
import { SimpleSelectFormInput, SimpleSelectFormInputProps } from '../FlexSalesForm';

export type JournalGroupFormInputProps = Omit<SimpleSelectFormInputProps, 'options' | 'value'>;

const journalGroups = ['SALES', 'COLLECTIONS'];

const journalGroupsFormatter: SimpleSelectOptionFormatter = {
  type: 'translation',
  translationIdBase: 'accountingEntries.journalGroups',
};

const JournalGroupFormInput = ({ disabled, ...others }: JournalGroupFormInputProps) => {
  const { t } = useTranslation();
  const options = useArrayToSimpleSelectOption(journalGroups, journalGroupsFormatter);

  return (
    <SimpleSelectFormInput
      {...others}
      label={t('accountingEntries.labels.journalGroup')}
      options={options}
    />
  );
};

export default JournalGroupFormInput;
